import { Tool } from '@thive/canvas';

import { DrawableToolId, ToolId } from '@modules/toolbar/types';
import { assertNever } from '@/helpers/utils';
import { AREAS_COLORS_MAP } from '@/modules/floorplanDesign/mappers/colors';

/**
 * @description Converts a ToolId to a canvas enum value
 * @param toolId The ToolId to convert
 * @returns The corresponding tool used in the canvas */
export function toolIdToCanvasTool(toolId: ToolId): Tool | undefined {
  switch (toolId) {
    case 'charging':
    case 'delivery':
    case 'intake':
    case 'manual':
    case 'insertion':
    case 'extraction':
    case 'parking':
    case 'process':
    case 'obstacle':
    case 'storage':
    case 'logical_space':
    case 'highway':
    case 'racking':
      return 'Draw.Shape';
    case 'highway_angled':
    case 'wall':
      return 'Draw.LinePath';
    case 'external_flow':
    case 'transport_flow':
    case 'consolidation_flow':
    case 'distcon':
    case 'scale_reference':
      return 'Draw.LineSticky';
    case 'cursor':
    case 'choose':
    case 'move_reference':
    case 'translate_by_move_origin':
      return 'Select';
    case 'pan':
      return 'Pan';
    case 'lassie':
    case 'lassie_mini':
    case 'shuttle':
    case 'hik':
      return 'Select';
    case 'goods_to_persons_flow': // can't draw this so this does nothing
      return;
    default:
      assertNever(toolId);
  }
}

/**
 * @description Returns a color for a given DrawableToolId
 * @param toolId DrawableToolId
 * @returns The corresponding color used in the canvas */
export function toolIdToColor(toolId: DrawableToolId): string {
  switch (toolId) {
    case 'charging':
      return AREAS_COLORS_MAP.CHARGING;
    case 'delivery':
      return AREAS_COLORS_MAP.DELIVERY;
    case 'intake':
      return AREAS_COLORS_MAP.INTAKE;
    case 'manual':
      return AREAS_COLORS_MAP.MANUAL;
    case 'insertion':
      return AREAS_COLORS_MAP.INSERTION;
    case 'extraction':
      return AREAS_COLORS_MAP.EXTRACTION;
    case 'parking':
      return AREAS_COLORS_MAP.PARKING;
    case 'process':
      return AREAS_COLORS_MAP.OFF_VEHICLE_PROCESSING;
    case 'obstacle':
      return AREAS_COLORS_MAP.OBSTACLE;
    case 'storage':
      return AREAS_COLORS_MAP.STORAGE;
    case 'logical_space':
      return AREAS_COLORS_MAP.LOGICAL_SPACE;
    case 'highway':
      return AREAS_COLORS_MAP.HIGHWAY;
    case 'racking':
      return AREAS_COLORS_MAP.STORAGE;
    case 'highway_angled':
      return AREAS_COLORS_MAP.HIGHWAY;
    case 'wall':
      return AREAS_COLORS_MAP.OBSTACLE;
    default:
      assertNever(toolId);
  }
}
